import { HelpsDataService } from './shared/helps-data.service';
import { HelpsConfigService } from './shared/helps-config.service';
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
  OnDestroy
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Logger } from '@app/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { environment } from "@env/environment";
import { FlowService } from '@app/flow/shared/flow.service';
import { LocalDataSource } from 'ng2-smart-table';
import { CategoryHelps } from '@app/shared/models/helps.model';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';

@Component({
  selector: 'iw-helps',
  templateUrl: './helps.component.html',
  styleUrls: ['./helps.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [FlowService, HelpsDataService, HelpsConfigService],

})
export class HelpsComponent implements OnInit, OnDestroy {
  // Define cuando esta cargando
  isLoading = false;
  isLoadingSearch = false;
  // Referencia de la modal
  modalRef: BsModalRef;
  // Datos para llenar la tabla
  sourceData: LocalDataSource = new LocalDataSource();
  // Configuracion de la tabla
  settings = {};
  // Contiene los templates de los controles personalizados
  templates = {};
  url = '';
  title = '';

  categories: CategoryHelps[] = [];

  // Referencia al template de la modal
  @ViewChild('helps') private templateD: TemplateRef<any>;
  // Referencia de el selector personalizado para los formularios
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  @ViewChild('modalIframe') private templateIframe: TemplateRef<any>;
  
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  private _idCategorySelect: any = null;

  set idCategorySelect(value: any) {
    if (value !== this.idCategorySelect) {
      this._idCategorySelect = value;
      //this.loadHelps();
    }
  }

  get idCategorySelect(): any {
    return this._idCategorySelect;
  }

  constructor(
    private modalService: BsModalService,
    private hds: HelpsDataService,
    private toastr: ToastrService,
    private fs: FlowService,
  ) { }

  ngOnInit() {
    this.templates = {
      ngSelectTpl: this.ngSelectTpl,
    };
    this._idCategorySelect = null;
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }


  /**
   * Loads the helps data.
   */
  loadHelps() {
    this.isLoadingSearch = true;
    this.sourceData.empty();
    this.hds.gethelps(this._idCategorySelect).subscribe((data: any) => {
      this.sourceData.load(data);
      this.isLoadingSearch = false;
    });
    }

  loadCategoryHelps(iframeClose: boolean = false) {
    if(!iframeClose){
      this._idCategorySelect = null;
      this.categories = [];
      this.isLoading = true;
      this.hds.getCategoryHelp().subscribe((data: any) => {
        this.categories = data;
        this.isLoading = false;
      });
    }
    
   

    
  }
  
    /**
   * Define las acciones ha realizar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @param {*} [data]
   * @memberof DynamicIframesComponent
   */
  defineActionCondictions(action: 'view', data?: any) {
    switch (action) {
      case 'view':
        this.openIframe(data.url, data.nombre);
        break;
    }
  }
  

  /**
   * Abre la modal con el formulario correspondiente
   *
   * @param {('trazabilidad' | 'tarea')} [type='trazabilidad'] // reporte a generar
   * @memberof HelpsComponent
   */
  open(iframeClose: boolean = false) {
    const configTable = new HelpsConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionCondictions(res.action, res.data);
    });
    this.loadCategoryHelps(iframeClose);
    this.modalRef = this.modalService.show(this.templateD, { class: 'modal-personalized', backdrop: 'static', keyboard: false });
  }

  openIframe(url: string, title: string, ) {
    this.modalRef.hide();
    this.url = url;
    this.title = title;
    this.modalRef = this.modalService.show(
      this.templateIframe,
      {
        class: 'modal-personalized',
        ignoreBackdropClick: true
      }
    );

    }
  
  
  onHide(e: boolean) {
      this.modalRef.hide();
    }

  /**
   * Cierra la modal
   *
   * @memberof HelpsComponent
   */
  close() {
    this.sourceData.empty();
    this._idCategorySelect = null;
    this.categories = [];
    this.modalRef.hide();
  }

  /**
   * Cierra la modal del iframe
   *
   * @memberof HelpsComponent
   */
  closeIframe(){
    this.url = '';
    this.title = '';
    this.modalRef.hide();
    this.open(true);
  }
}


// WEBPACK FOOTER //
// ./src/app/helps/helps.component.ts